<template>
	<div>
		<SOModalExport
			:is-running="isExporting"
			:context="''"
			:total-data="`${countData} Settlement`"
			:export-data-exist="exportData.length > 0 ? exportData.filter((v) => v.downloaded === false).length : 0"
			@close="closeModal"
			@do-export="doExport"
		/>
	</div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

import SOModalExport from "@/so-components/global/modal/SOModalExport";

import {moduleName} from "../store/state";

export default {
	name: "SOExportModal",
	components: {
		SOModalExport,
	},
	computed: {
		...mapGetters(moduleName, {
			isExporting: "exporting",
			countData: "countData",
			exportData: "exportData",
		}),
	},
	data() {
		return {
			key: "",
		}
	},
	mounted() {
		this.key = this.$route.query.key
	},
	methods: {
		...mapActions({
			toggleExporting: `${moduleName}/toggleExporting`,
			doExportData: `${moduleName}/exportData`,
		}),
		closeModal() {
			this.$router.back();
		},
		async doExport() {
			await this.closeModal();
			await this.toggleExporting(true);
			await this.doExportData(this.key);
		},
	},
};
</script>
